export default __webpack_public_path__ + "static/joko-app-screenshot-home-2-en-120c9971ef11cc8677547ecc8b6c9aae.png";